'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import type { CategoriesEntity } from '@eliadmin/core/src/api/general/types/general-layout-types';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Link from '@eliadmin/core/src/components/link';
import type { HTMLAttributes } from 'react';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { Carousel } from '@eliadmin/core/src/components/ui/carousel';

type HomepageCategoriesClassName = {
  main?: string;
  controlButton?: string;
  list?: string;
  listItem?: string;
  listItemImage?: string;
  listItemChevron?: string;
  link?: string;

  hoverCard?: string;
  hoverCardHeader?: string;
  hoverCardHeaderTitle?: string;
  hoverCardContent?: string;
  hoverCardList?: string;
  hoverCardListItem?: string;
  hoverCardLink?: string;
};
export interface HomepageCategoriesProps {
  className?: HomepageCategoriesClassName;
  style?: HTMLAttributes<HTMLElement>['style'];
  categories?: CategoriesEntity[];
  loading?: boolean;
  expandable?: boolean;
  showImage?: boolean;
}

export const HomepageCategories = ({
  className,
  style,
  categories,
  expandable = true,
  showImage = true,
}: HomepageCategoriesProps) => {
  return (
    <div
      className={cn(
        'relative flex items-center justify-center py-1',
        'ea-homepage-categories__main',
        className?.main,
      )}
      style={style}
    >
      {categories && (
        <Carousel
          className={{
            main: 'w-full @container',
            container: 'flex min-w-full gap-2',
            slide: 'h-full min-h-full w-full p-2 sm:w-[175px]',
          }}
          slides={categories?.map(category => (
            <li
              key={category.id ?? category.slug}
              className={cn(
                'group flex h-full w-full min-w-[140px] flex-col items-center rounded-lg bg-background p-8 text-center transition-colors hover:bg-primary md:max-w-none',
                'ea-homepage-categories__list-item hover:cursor-pointer hover:bg-primary',
                className?.listItem,
              )}
            >
              <Link
                href={category.slug}
                className={cn(
                  'flex flex-col items-center gap-2 text-wrap text-[14px] font-semibold group-hover:text-primary-foreground',
                  'ea-homepage-categories__list-item-link',
                  className?.link,
                )}
                prefetch={false}
              >
                {category.image && showImage && (
                  <Image
                    alt={resolveImageAlt(category?.image, category?.name, undefined)}
                    src={category.image.url}
                    width={0}
                    height={0}
                    sizes={'100vw'}
                    className={cn(
                      'h-12 w-12 rounded-full bg-background p-2 transition-colors',
                      'ea-homepage-categories__list-item-image group-hover:bg-white',
                      className?.listItemImage,
                    )}
                  />
                )}
                {category.name}
              </Link>
            </li>
          ))}
          options={{
            align: 'start',
            loop: false,
          }}
        />
      )}
    </div>
  );
};
